import { useState } from "react";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import { useAppDispatch } from "../../../../redux/hooks";
import { useNavigate } from "react-router-dom";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import { FleetDocumentsDataInterface } from "../../../../redux/interfaces/fleet.interface";
import { setFleetDocumentData } from "../../../../redux/reducer/fleet.reducer";
import FormButtons from "../../../../components/misc/FormButtons";
import { getDateAndTime } from "../../../../utils/dateAndTime";

function ExistingDocumentsWrapper({
  fleetDocumentsWithoutExpired,
}: {
  fleetDocumentsWithoutExpired: FleetDocumentsDataInterface[];
  handleSubmit: () => void;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { routeMainParam } = useRoutesHelper();
  const { carId } = routeMainParam as { carId: string };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCardClick = (documentData: FleetDocumentsDataInterface) => {
    dispatch(setFleetDocumentData(documentData));
    handleClose();

    const url = `/fleet/${carId}/documents`;
    window.open(url, "_blank");
  };

  return (
    <>
      <ModalWrapper
        title="Acest document exista deja"
        show={showModal}
        handleClose={handleClose}>
        {fleetDocumentsWithoutExpired.map((item) => {
          return (
            <button
              type="button"
              onClick={() => handleCardClick(item)}
              key={item.id_denumire}
              className="w-full cursor-pointer border-0 border-b border-slate-200 bg-transparent py-3 text-left transition hover:bg-surface-hover">
              <h2 className="text-lg font-bold text-gray-900">
                {item.denumire}
              </h2>
              <div className="flex justify-between gap-4 text-sm text-muted-dark">
                <p>Creat: {getDateAndTime(item.doc_ts_start)}</p>
                <p className="text-danger">
                  Expira: {getDateAndTime(item.doc_ts_stop)}
                </p>
              </div>
            </button>
          );
        })}
        <FormButtons
          goBackLabel="Inapoi"
          handleGoBack={handleClose}
          // goNextLabel="Creaza"
          // handleGoNext={handleSubmit}
        />
      </ModalWrapper>
      <FormButtons
        goBackLabel="Inapoi"
        nextButtonType={"button"}
        goNextLabel={"Documente existente"}
        nextButtonVariant="action"
        nextButtonIcon="MULTIPLE_DOCUMENTS"
        handleGoBack={() => navigate(-1)}
        handleGoNext={() => setShowModal(true)}
      />
    </>
  );
}

export default ExistingDocumentsWrapper;
